import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiaApi from '../../../api/apiaApi/apiaApi';
import { notify } from '../../../components/common/notifications/util';
import { makeGridActionUrl } from '../actionsUtils';
import { TApiaXMLResponse, TDataGridThunkState } from '../types';
import { shouldDebugGridActions } from './add';
import { TRowActionResponse } from './types';

const gotoPage = createAsyncThunk<
  TRowActionResponse | null,
  {
    gridId: string;
    page: number;
  },
  TDataGridThunkState
>('dataGridSlice/gotoPage', async ({ gridId, page }, thunkApi) => {
  const state = thunkApi.getState().dataGridSlice[gridId];
  const result = await ApiaApi.post<TApiaXMLResponse>(
    makeGridActionUrl({
      gridAction: 'gotopage',
      context: state.context,
      startIndex: state.context.grid.field.startIndex,
      page,
    }),
  );
  if (shouldDebugGridActions) console.log('gotoPage', page, result?.data);
  if (result?.data)
    return {
      xmlResponse: result.data,
      focusRow: 0,
      newSelectedRows: [0],
    };

  notify({
    message: 'Error on DataGrid action',
    type: 'danger',
  });
  return null;
});

export default gotoPage;
